<template>
    <transition
      :name="transition"
    >
      <div
        v-if="show && simple"
        class="cookie-bar"
        role="region"
        aria-label="Cookie consent"
      >
        <p class="cookie-bar__text">{{ message }}</p>
        <div class="cookie-bar__actions">
          <button type="button" class="cookie-bar__btn cookie-bar__btn--accept" @click="accept">Accept</button>
          <button type="button" class="cookie-bar__btn cookie-bar__btn--reject" @click="reject">Reject</button>
        </div>
      </div>
      <div
        v-else-if="show"
        class="cookie-consent"
        role="dialog"
      >
        <slot
          name="message"
        >
          <span
            class="cookie-consent-message"
          >
            {{ message }}
            <slot
              name="link"
            >
              <v-btn
               @click="details=true"
                class="cookie-consent-link"
                role="button"
                style="margin-right:5px;"
              >
                {{ linkLabel }}
              </v-btn>
            </slot>
          </span>
        </slot>
        <section
          @click="accept"
        >
          <slot
            name="button"
          >
            <v-btn
              class="cookie-consent-compliance"
              type="button"
            >
              {{ acceptButtonLabel }}
            </v-btn>
          </slot>
        </section>
        <v-dialog v-model="details" max-width="800">
            <v-card>
              <v-card-title>
                Cookie Options
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <p>We use cookies to help you navigate efficiently and perform certain functions. You will find detailed information about all cookies under each consent category below.</p>

                    <p>The cookies that are categorised as "Necessary" are stored on your browser as they are essential for enabling the basic functionalities of the site.</p>

                    <p>We also use third-party cookies that help us analyse how you use this website, store your preferences, and provide the content and advertisements that are relevant to you. These cookies will only be stored in your browser with your prior consent.</p>

                    <p>You can choose to enable or disable some or all of these cookies but disabling some of them may affect your browsing experience. Changes will be saved automatically.</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col><p>Necessary cookies are required to enable the basic features of this site, such as providing secure log-in or adjusting your consent preferences. These cookies do not store any personally identifiable data.</p></v-col>
                  <v-col><v-switch :disabled="true" v-model="necessary" label="Necessary cookies"></v-switch></v-col>
                </v-row>

                <v-row>
                  <v-col><p>Functional cookies help perform certain functionalities like sharing the content of the website on social media platforms, collecting feedback, and other third-party features.</p></v-col>
                  <v-col><v-switch v-model="functional" label="Functional cookies"></v-switch></v-col>
                </v-row>
                <v-row>
                  <v-col><p>Analytical cookies are used to understand how visitors interact with the website. These cookies help provide information on metrics such as the number of visitors, bounce rate, traffic source, etc.</p></v-col>
                  <v-col><v-switch v-model="analytical" label="Analytics cookies"></v-switch></v-col>
                </v-row>
                <v-row>
                  <v-col><p>Performance cookies are used to understand and analyze the key performance indexes of the website which helps in delivering a better user experience for the visitors.</p></v-col>
                  <v-col><v-switch v-model="performance" label="Performance cookies"></v-switch></v-col>
                </v-row>
                <v-row>
                  <v-col><p>Advertisement cookies are used to provide visitors with customized advertisements based on the pages you visited previously and to analyze the effectiveness of the ad campaigns.</p></v-col>
                  <v-col><v-switch v-model="advertisement" label="Advertisement cookies"></v-switch></v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="justify-center pb-4">
                <v-btn
                  @click="reject"
                  class="cookie-consent-compliance mr-4"
                  type="button"
                >
                  {{ rejectButtonLabel }}
                </v-btn>
                <v-btn
                  @click="accept"
                  class="cookie-consent-compliance"
                  type="button"
                >
                  {{ acceptButtonLabel }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </div>
    </transition>
  </template>
  </template>

  <script>
    export default {
      name: 'CookieConsent',

      props: {
        // A plain Accept / Reject bar (home page design) instead of the
        // settings dialog. Same cookie and Google consent handling.
        simple: {
          type: Boolean,
          default: false
        },
        // default
        transition: {
          type: String,
          default: 'cookie-consent-transition'
        },
        message: {
          type: String,
          default:"This website uses cookies to improve your experience. You can choose to accept or reject cookies."
        },
        // button
        linkLabel: {
          type: String,
          default: 'Settings'
        },
        acceptButtonLabel: {
          type: String,
          default: 'Accept all'
        },
        rejectButtonLabel: {
          type: String,
          default: 'Accept only necessary'
        },
        href: {
          type: String,
          default: 'https://backtoworkconnect.ie'
        },
        target: {
          type: String,
          default: '_blank'
        },
        rel: {
          type: String,
          default: 'noopener'
        },
        // cookie
        cookieName: {
          type: String,
          default: 'cookieconsent_status'
        },
        cookiePath: {
          type: String,
          default: '/'
        },
        cookieDomain: {
          type: String,
          default: ''
        },
        cookieExpiryDays: {
          type: Number,
          default: 365
        }
      },
      watch: {
        analytical: function(val) {
          this.updateCookie();
          this.updateGoogleConsent();
        },
        functional: function(val) {
          this.updateCookie();
          this.updateGoogleConsent();
        },
        performance: function(val) {
          this.updateCookie();
          this.updateGoogleConsent();
        },
        advertisement: function(val) {
          this.updateCookie();
          this.updateGoogleConsent();
        }
      },
      data() {
        return {
          details: false,
          show: undefined,
          necessary: true,
          optional: true,

          functional: true,
          analytical: true,
          performance: true,
          advertisement: true,
          cookieVal: {
            'ad_storage': 'denied',
            'analytics_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied',
            'functionality_storage': 'denied',
            'personalization_storage': 'denied',
            'security_storage': 'granted'
          }
        }
      },
      computed: {
        cookie() {
          return !this.getCookie(this.cookieName)
        }
      },
      beforeMount() {
        this.show = this.cookie;

        let savedCookie = this.getCookie(this.cookieName);

        if (savedCookie && typeof savedCookie === 'object') {
          // Update local state based on saved cookie values
          this.cookieVal = savedCookie;
          this.analytical = savedCookie.analytics_storage === 'granted';
          this.advertisement = savedCookie.ad_storage === 'granted';
          this.functional = savedCookie.functionality_storage === 'granted';
          this.performance = savedCookie.personalization_storage === 'granted';
        }

        // Initialize Google consent with current values
        if (window.gtag) {
          window.gtag('consent', 'default', this.cookieVal);
        }
      },
      methods: {
        updateGoogleConsent() {
          // Update Google consent settings based on user preferences
          console.log('Google Consent:', window.gtag, this.cookieVal);
          if (window.gtag) {
            window.gtag('consent', 'update', this.cookieVal);
          }
        },
        updateCookie() {
          this.cookieVal = {
            'ad_storage': this.advertisement ? 'granted' : 'denied',
            'analytics_storage': this.analytical ? 'granted' : 'denied',
            'ad_user_data': this.advertisement ? 'granted' : 'denied',
            'ad_personalization': this.advertisement ? 'granted' : 'denied',
            'functionality_storage': this.functional ? 'granted' : 'denied',
            'personalization_storage': this.performance ? 'granted' : 'denied',
            'security_storage': 'granted' // Always granted for necessary cookies
          }
          this.setCookie(this.cookieName, JSON.stringify(this.cookieVal), this.cookieExpiryDays, this.cookieDomain, this.cookiePath);
        },
        reject() {
          this.show = false;
          this.advertisement = false;
          this.functional = false;
          this.performance = false;
          this.analytical = false;
          this.updateCookie();
          this.updateGoogleConsent();
        },
        accept() {
          this.show = false;
          this.updateCookie();
          this.updateGoogleConsent();
        },
        getCookie(name) {
          const value = `; ${document.cookie}`;
          const parts = value.split(`; ${name}=`);
          if (parts.length !== 2) return undefined;

          const cookieValue = parts.pop().split(';').shift();
          try {
            return JSON.parse(cookieValue);
          } catch (e) {
            return cookieValue;
          }
        },
        setCookie(name, value, expiryDays, domain, path) {
          const exdate = new Date();
          exdate.setDate(exdate.getDate() + (expiryDays || 365));
          const cookie = [
            `${name}=${value}`,
            `expires=${exdate.toUTCString()}`,
            `path=${(path || '/')}`
          ];
          if (domain) {
            cookie.push(`domain=${domain}`);
          }
          document.cookie = cookie.join(';');
        }
      }
    }
  </script>
  <style scoped>
.cookie-consent {
  position: fixed !default;
  z-index: 9999 !default;
  width: 100% !default;
  padding: 3rem 0 !default;

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  background: #ced4da !default;

}


.cookie-consent-compliance {
    cursor: pointer;
    color: #fff !default;
    padding: .5rem 2rem !default;
    background: #237afc !default;
    border: 2px solid currentColor !default;
  }

    .cookie-consent-transition-leave-active {
    transition: transform .75s;
    transition-timing-function: cubic-bezier(.75,0,0,1);
  }
  .cookie-consent-transition-leave-to {
    transform: translateY(100%);
  }

  .cookie-consent {
  left: 0;
  right: 0;
  bottom: 0;
}

.cookie-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 16px clamp(20px, 4vw, 64px);
  background: #F6F1F5;
  box-shadow: 0 -4px 16px rgba(86, 3, 84, .08);
  font-family: 'Montserrat', sans-serif;
  line-height: normal;
}
.cookie-bar__text {
  margin: 0;
  font-size: 14px;
  color: #675B46;
}
.cookie-bar__actions {
  display: flex;
  gap: 10px;
}
.cookie-bar__btn {
  border: 1px solid #560354;
  border-radius: 999px;
  padding: 10px 24px;
  font: 600 14px 'Montserrat', sans-serif;
  cursor: pointer;
  transition: background-color .15s;
}
.cookie-bar__btn--accept {
  background: #560354;
  color: #FFFFFF;
}
.cookie-bar__btn--accept:hover {
  background: #42003F;
}
.cookie-bar__btn--reject {
  background: transparent;
  color: #560354;
}
.cookie-bar__btn--reject:hover {
  background: #F1E6F0;
}
@media (max-width: 639px) {
  .cookie-bar {
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
    padding: 18px 20px 20px;
  }
  .cookie-bar__text {
    font-size: 13px;
    line-height: 1.5;
  }
  .cookie-bar__actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .cookie-bar__btn {
    min-height: 44px;
    padding: 12px 0;
  }
}

    </style>
